import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StudyInstanceItem, StudyInstancesTableSelectorComponent } from '../../../shared/study-instances-table-selector/study-instances-table-selector.component';
import { DatasetTypeEnum } from '../../../../shared/dataset/model/dataset-type.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DatasetService } from '../../../../shared/dataset/service/dataset.service';
import { StudyEditorContext } from '../../../study-editor.context';
import { VariableService } from '../../../../shared/ontology/service/variable.service';
import { AlertService } from '../../../../shared/alert/alert.service';
import { SubObservationInfoModel } from './sub-observation-info.model';
import { StudyEditorService } from '../../../study-editor.service';

@Component({
    selector: 'jhi-sub-observation-unit-dataset-builder-modal',
    templateUrl: './sub-observation-unit-dataset-builder-modal.component.html',
    styleUrl: './sub-observation-unit-dataset-builder-modal.component.scss'
})
export class SubObservationUnitDatasetBuilderModalComponent implements OnInit {

    readonly SUB_OBSERVATION_DATASETS: DatasetTypeEnum[] = [
        DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
        DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
        DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS,
        DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS];

    @ViewChild('dtForm') dtForm: NgForm;

    @Input() selectedDatasetType: any;
    @Input() subObservationInfoModels: SubObservationInfoModel[];

    studyInstanceItems: StudyInstanceItem[] = [];
    selectedVariable: any;
    selectedSubObsDataset: any;
    isDropDownTemplateChecked = false;
    templateDatasets: any[] = [];
    numberOfSubObservationUnits = 1;
    datasetName = '';
    submitted = false;
    variables: any[] = [];
    isEmptySelection = false;
    plotDatasetId: number;
    maxSubObservationParentUnit: number;

    constructor(private activeModal: NgbActiveModal,
                private datasetService: DatasetService,
                private studyEditorContext: StudyEditorContext,
                private variableService: VariableService,
                private alertService: AlertService,
                private studyEditorService: StudyEditorService,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.initDatasetBuilder();
    }

    cancel(): void {
        this.activeModal.dismiss();
    }

    getHeader(label: string) {
        const param = this.translateService.instant(label);
        return this.translateService.instant('study-editor.subobservation-modal.header', { param });
    }

    changeTemplate(): void {
        if (this.selectedSubObsDataset) {
            this.datasetName = this.selectedSubObsDataset.datasetName;
            this.numberOfSubObservationUnits = this.selectedSubObsDataset.numberOfSubObservationUnits;
            this.selectedVariable = this.selectedSubObsDataset.variable;
            this.isDropDownTemplateChecked = true;
        }
    }

    initDatasetBuilder () {

        this.datasetName = '';
        this.maxSubObservationParentUnit = this.studyEditorContext.maxSubObservationParentUnit;
        this.numberOfSubObservationUnits = undefined;
        this.selectedVariable = undefined;
        this.selectedSubObsDataset = undefined;
        this.isDropDownTemplateChecked = false;
        this.datasetService.getDatasetInstances(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId).toPromise().then((datasetInstances) => {
            this.studyInstanceItems = datasetInstances as StudyInstanceItem[];

            this.studyInstanceItems.forEach((instance) => {
                instance.isChecked = true;
            });

            this.variableService.searchVariables({
                methodIds: [4040],
                scaleIds: [6040],
                variableTypeIds: [1812]
            }).toPromise().then((variablesFiltered)=> {
                this.variables = variablesFiltered.body;
                this.variables.forEach((variable)=> {
                    if (this.selectedDatasetType.defaultVariableId === parseInt(variable.id, 10) || (this.selectedSubObsDataset
                        && parseInt(variable.id, 10) === parseInt(this.selectedSubObsDataset.sequenceVariableId, 10))) {
                        this.selectedVariable = variable;
                    }
                });
            });

            this.datasetService.getTemplateStudy(this.studyEditorContext.studyId).toPromise().then((templateDataset) => {
                this.templateDatasets = [];
                templateDataset.subObsDatasets.forEach((templateSubObsDataset) => {
                    if (this.selectedDatasetType.id === parseInt(templateSubObsDataset.datasetTypeId, 10)) {
                        this.templateDatasets.push(templateSubObsDataset);
                        if (this.templateDatasets.length === 1) {
                            this.selectedSubObsDataset = templateSubObsDataset;
                            this.changeTemplate();
                        }
                    }
                });
            });
        });

        this.plotDatasetId = this.studyEditorContext.getPlotDataset().datasetId;
    }

    saveDataset() {

        this.isEmptySelection = this.studyInstanceItems.filter((instance) => instance.isChecked).length === 0;

        if (this.dtForm.valid && !this.isEmptySelection) {
            const instanceIds = [];

            this.studyInstanceItems.forEach((studyInstanceItem)=> {
                if (studyInstanceItem.isChecked) {
                    instanceIds.push(studyInstanceItem.instanceId);
                }
            });

            const newDataset = {
                'datasetTypeId': this.selectedDatasetType.id,
                'datasetName': this.datasetName,
                'instanceIds': instanceIds,
                'sequenceVariableId': parseInt(this.selectedVariable.id, 10),
                'numberOfSubObservationUnits': this.numberOfSubObservationUnits,
                'templateDatasetId': this.selectedSubObsDataset ? this.selectedSubObsDataset.datasetId : undefined
            };

            this.datasetService.generation(this.studyEditorContext.studyId, this.plotDatasetId, newDataset).toPromise().then((datasetModel)=> {
                this.alertService.success('study-editor.sub-observation-dataset-builder.success');
                this.studyEditorService.triggerRefreshAndWait().then(() => {
                    this.studyEditorService.navigateToDatasetTab(this.studyEditorContext.studyId, datasetModel.datasetId);
                    this.activeModal.close();
                });
            });
        }
    };
}
